<script setup lang="ts">
import { ref } from 'vue'
import { testimonials } from '../../../content'

const currentSlide = ref(0)

const goToSlide = (index: number) => {
  currentSlide.value = index
}
</script>

<template>
  <section id="testimonials" class="testimonials">
    <div class="container">
      <div class="section-header animate animate--fade-up">
        <h2 class="section-header__title">{{ testimonials.headline }}</h2>
      </div>

      <div class="testimonial-slider animate animate--fade-up animate--delay-1">
        <div class="testimonial">
          <p class="testimonial__quote">{{ testimonials.items[currentSlide].quote }}</p>
          <p class="testimonial__author">&mdash; {{ testimonials.items[currentSlide].author }}</p>
        </div>

        <div class="slider-dots">
          <button
            v-for="(_, index) in testimonials.items"
            :key="index"
            :class="['slider-dot', { 'slider-dot--active': index === currentSlide }]"
            @click="goToSlide(index)"
            :aria-label="`Go to slide ${index + 1}`"
          />
        </div>
      </div>
    </div>
  </section>
</template>
